import { useAuth } from '../../contexts/AuthContext';
import AdminDashboard from './admin/AdminDashboard';
import InstructorDashboard from './instructor/InstructorDashboard';
import StudentDashboard from './student/StudentDashboard';
import ReceptionKioskPage from '../reception/ReceptionKioskPage';
import { WorkspacePageLoader, WorkspaceShell } from '../ui/Workspace';

const Dashboard = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <WorkspacePageLoader />;
  }

  if (!currentUser) {
    return null; // The AppLayout will handle the redirect
  }

  // Render appropriate dashboard based on user role
  switch (currentUser.role) {
    case 'admin':
    case 'manager':
      return <AdminDashboard />;
    case 'instructor':
    case 'demonstrator':
      return <InstructorDashboard />;
    case 'student':
      return <StudentDashboard />;
    case 'staff':
      return <ReceptionKioskPage />;
    default:
      return (
        <WorkspaceShell title="Dashboard" description="Your account does not have a workspace view yet.">
          <p className="text-sm text-gray-500">No dashboard available for your role.</p>
        </WorkspaceShell>
      );
  }
};

export default Dashboard;
